<template>
    <div class="py-1">
        <div v-if="hasRecipient" class="recipient text-truncate font-weight-bold">
            <span v-if="object.registration.email_recipient !== null" class="text-mono"><i class="fa fa-envelope"></i> {{ object.registration.email_recipient }}</span>
            <span v-else class="text-mono"><i class="fa fa-lg fa-mobile-phone"></i> {{ object.registration.recipient }}</span>
             - <span>{{ object.name }}</span>
        </div>
        <span v-if="object.status == 3" v-html="formatedDate"></span>
        <div v-if="object.status == 1">
            <span>{{ $t('device.registrations.expires') }}</span>
            <Countdown :date="object.registration.liveUntil" :timezone="timezone" :item="object" @expired="handleExpired"></Countdown>
        </div>
        <span v-if="object.status == 2" class="font-bold phone-simple-renderer">
            <router-link :to="'/devices/'+object.id" v-if="phoneName != ''">
                <span :title="phoneName">{{ phoneName }}</span>
                <img :src="urlImg"/>
            </router-link>
        </span>
        <span v-if="object.hasOlderDevice == true && object.imei == null && object.status != 1 && object.status != 3">
            <span>{{ $t('device.registrations.previously') }}<br><strong>{{ phoneName }}</strong></span>
        </span>
    </div>
</template>

<script>

    import API from '@/services/API.js';
    import Utils from '@/services/utils.js';
    import moment from 'moment';
    import 'moment-timezone';
    import Countdown from '@/components/ui/Countdown';

    var sha1 = require('sha1');

    // Status: 0:pas d'invit, 1: Invit en cours, 2: Invit validée, 3: Invit expirée

    export default {
        name: 'inforenderer',
        components: {Countdown},
        props: ['object'],
        computed: {
            hasRecipient: function(){
                if(this.object.registration != null && this.object.imei == null){
                    return (this.object.registration.recipient != null || this.object.registration.email_recipient != null) || false;
                }
                return false;
            },
            formatedDate: function () {
                switch (this.object.status){
                    case 3:
                        return moment(this.object.registration.liveUntil.date).tz(this.object.registration.liveUntil.timezone).format('['+Utils.t('device.registrations.expired')+'<strong>] '+Utils.t('datetime.date')+' ['+Utils.t('global.at')+'] HH:mm[</strong>]');
                        break;
                }
            },
            phoneName: function(){
                if(this.object.name != null){
                    return this.object.name;
                }
                return '';
            }
        },
        data: () => ({
            urlImg: '',
            timezone: ''
        }),
        methods: {
            handleExpired: function(item){
                this.$emit('expired',item);
            }
        },
        watch: {
            object: function(newObject){
                if(newObject.deviceManufacturer != '' && newObject.deviceModel != ''){
                    var hash = sha1(newObject.deviceManufacturer.toLowerCase() + newObject.deviceModel.toLowerCase().replace(new RegExp(' ', 'g'), ''));
                    this.urlImg = API.route(API.endpoints.datis.picture,{hash:hash});

                }
            }
        },
        mounted: function(){
            this.timezone = moment.tz.guess()
        }
    }
</script>

<style lang="scss" scoped>

</style>
